<template>
	<div>
		<!-- swiper 插件 轮播图 -->
		<div class="banner">
			<img :src="pageData.banner" alt="">
			<div class="title">{{pageData.title}}</div>
		</div>

		<!-- 内容容器 -->
		<div class="content-wrapper">
			<section class="data0">
				<div class="content">
					<div class="desc" v-html="pageData.data0.content">
						<!-- <span>{{pageData.data0.title}}</span>{{pageData.data0.desc}} -->
					</div>
				</div>
			</section>
			<section class="data1">
				<div class="content">
					<div class="desc" v-html="pageData.data1.content">
						<!-- <div class="item" v-for="(item, index) in pageData.data1.lists" :key="index">
							<span>{{item.title}}:</span>{{item.desc}}
						</div> -->
					</div>
				</div>
			</section>
			<section class="data3">
				<div class="content">
					<div class="lists" >
            <template v-for="(item, index) in pageData.data3">
              <div  :key="index" class="item" v-html="item.content" v-if="item.isShow == '1'"></div>
                <!-- <div><span class="number">{{item.number}}</span><span class="unit">{{item.unit}}</span></div>
                <div class="desc">{{item.desc}}</div> -->
            </template>
					</div>
				</div>
			</section>
			<section class="data4">
				<div class="content">
          <div class="title">{{pageData.data4.title}}</div>
					<!-- <div class="data4-swiper-box" :style=" {backgroundImage:'url('+pageData.data4.lists[0].imgUrl+')'}"> -->
					<div class="data4-swiper-box">
            <img class="bg" :src="data4ImgBg" alt="">
            <div class="time-axis">
              <div class="line">
                <div class="time" v-for="(time, t) in pageData.data4.lists" :key="t" @click="changeSwiper(t)">
                  <img v-if="t === data4SwiperIndex" src="../assets/images2/history_btn_sel@2x.png" alt="">
                  <img v-else src="../assets/images2/history_btn_nor@2x.png" alt="">
                  <div class="value" :class="{on: t === data4SwiperIndex}">{{time.startYear}}-{{time.endYear}}</div>
                </div>
              </div>
            </div>
						<div class="data4-swiper">
							<div class="swiper-wrapper">
								<div class="swiper-slide" v-for="(item, index) in pageData.data4.lists" :key="index">
									<!-- <img class="bg" :src="item.imgUrl" alt=""> -->
									<div class="backdrop"></div>
									<!-- <div class="time-axis">
										<div class="line">
											<div class="time" v-for="(time, t) in pageData.data4.lists" :key="t" @click="changeSwiper(t)">
												<img v-if="t === index" src="../assets/images2/history_btn_sel@2x.png" alt="">
												<img v-else src="../assets/images2/history_btn_nor@2x.png" alt="">
												<div class="value" :class="{on: t === index}">{{time.startYear}}-{{time.endYear}}</div>
											</div>
										</div>
									</div> -->
									<div class="text-box">
                    <div class="text">
                      <template v-for="(item, index) in handleBrArr(item.content)">
                        <div :key="index" v-if="item">
                          {{item}}
                        </div>
                      </template>
                    </div>
                    <!-- <div class="text" v-html="handleBrTag(item.content)"></div> -->
										<!-- <div class="title">{{item.title}}</div> -->
										<!-- <div class="sub_title">{{item.sub_title}}</div> -->
										<div class="value">{{pageData.data4.lists[data4SwiperIndex].startYear}}-{{pageData.data4.lists[data4SwiperIndex].endYear}}年</div>
									</div>
									<div class="after-content">{{pageData.data4.lists[data4SwiperIndex].startYear}}-{{pageData.data4.lists[data4SwiperIndex].endYear}}</div>
								</div>
							</div>
						</div>
						<div class="swiper-button-prev swiper-btn swiper-left"></div>
						<div class="swiper-button-next swiper-btn swiper-right"></div>
					</div>
				</div>
			</section>
			<section class="data5">
				<div class="content">
					<div class="title border">{{pageData.data5.title}}</div>
					<div class="data5-swiper-box">
						<div class="data5-swiper">
							<div class="swiper-wrapper">
								<div class="swiper-slide" v-for="(item, index) in pageData.data5.lists" :key="index">
									<img :src="item.imgUrl" alt="">
								</div>
							</div>
						</div>
						<div class="swiper-button-prev swiper-btn swiper-left"></div>
						<div class="swiper-button-next swiper-btn swiper-right"></div>
					</div>
				</div>
			</section>

			<section class="data2">
				<div class="content">
					<img :src="pageData.data2.img" alt="">
					<div class="text-box">
						<div class="title">{{pageData.data2.title}}</div>
						<div class="sub_title">{{pageData.data2.sub_title}}</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
	import mixins from '@/mixins';
  import Swiper from 'swiper';
	import { companyItemList, bannerList, indexDataList, getAppInfo, itemList } from '@/utils/api';

	export default {
    name: 'About',
    mixins: [mixins],
		props: {},
		components: {},
		data() {
			return {
				screenWidth: 0,
				screenHeight: 0,
				activeNav: 'about',
				pageData: {
					banner: '',
					title: '关于奔腾达',
					// 我的服务
					data0: {
            content: '',
						title: '广东奔腾达电子有限公司',
						desc: '成立于1995年。公司专注于提供金融科技解决方案，服务于中国金融体系。我们一直秉承客户至上，产品优质，团队合作，服务可靠的价值观。我们的业务包括金融智能设备、设备智能运维、生物识别、人工智能、4G网络设备、新金融互动屏、IT服务器监测以及创新项目和其他业务，同时与国内外多家行业领先的科技企业有战略合作。',
					},
					// 各行业；
					data1: {
            content: '',
            lists: [
              {
                title: '企业愿景',
                desc: '成为金融科技生态领军企业',
              },
              {
                title: '企业使命',
                desc: '科技赋能智慧金融',
              },
              {
                title: '核心价值观',
                desc: '城市、专业、实干、创新、共赢',
              },
              {
                title: '公司口号',
                desc: '奔腾起来, 使命必达',
              },
            ],
          },
					data2: {
						title: '业务版图',
						sub_title: '标语标语标语标语标语',
						img: '',
					},
					data3: [],
					data4: {
						title: '发展历程',
						bg: '',
						line: '',
						times: [],
						lists: []
          },
          data5: {
            show: 0,
            title: '资质优势',
            lists: []
          }
				},
				data2Index: 0,
				serviceIndex: 0,
				dialogVisible: false,
				saving: false,
				formData: {},
        editRules: [],
        data4Swipers: '',
        data4ImgBg: '',
        data4SwiperIndex: 0
			};
		},
		components: {},
		created() {
			this.$store.commit('activeNav', 'about');
      this.init();
		},
		computed: {},
		mounted() {
			var that = this;
			this.data4Swipers = new Swiper('.data4-swiper', {
        autoplay: {
					delay: 5000,
					disableOnInteraction: false
        },
        observer: true,
        observeParents:true,
				navigation: {
					nextEl: '.data4-swiper-box .swiper-button-next',
          prevEl: '.data4-swiper-box .swiper-button-prev',
          disabledClasee: 'swiper-btn-disabled'
        },
        on: {
          click(e) {
            console.log('click--e==', e);
          },
          slideChange(event) {
            console.log('slideChange--event==', event);
            console.log('slideChange--this.activeIndex==', this.activeIndex);
						that.data4SwiperIndex = this.activeIndex;
					}
        }
      });
      var data5Swipers = new Swiper('.data5-swiper', {
        // loop: true, // 循环模式选项
        autoplay: {
					delay: 3000,
					disableOnInteraction: false
				},
        observer: true,
        observeParents:true,
				navigation: {
					nextEl: '.data5-swiper-box .swiper-button-next',
					prevEl: '.data5-swiper-box .swiper-button-prev',
				},
			});
		},
		methods: {
      changeSwiper(index) {
        console.log('changeSwiper--index==', index);
        this.data4SwiperIndex = index;
        this.data4Swipers.slideTo(index);

      },
      async init() {
        const res0_1 = await getAppInfo('key-about-m-title');
        this.pageData.title = res0_1.data.baseData.content;
        console.log('about--res0_1==', res0_1);
        const res0_2 = await getAppInfo('key-about-m-imgUrl');
        this.pageData.banner = res0_2.data.baseData.content;
        console.log('about--res0_2==', res0_2);


        // 公司介绍
        const res0 = await getAppInfo('key-about-info-content');
        this.pageData.data0.content = res0.data.baseData.content;
        console.log('about--res0==', res0);

        // 企业文化
        const res1 = await getAppInfo('key-about-cul-content');
        this.pageData.data1.content = res1.data.baseData.content;
        console.log('about--res1==', res1);

        // 资质优势模块名
        const res3 = await getAppInfo('key-about-m-advantage-title');
        this.pageData.data2.content = res3.data.baseData.content;
        console.log('about--res3==', res3);

        // 公司介绍1
        // const res4 = await getAppInfo('key-about-info1-content');
        // this.pageData.data3.content = res4.data.baseData.content;        
        // console.log('about--res4==', res4);

        const res5 = await companyItemList();
        this.pageData.data3 = res5.data.baseData || [];
        console.log('about--res5==', res5);

        const res6 = await itemList({type: 4});
        this.pageData.data4.lists = res6.data.baseData || [];
        this.data4ImgBg = this.pageData.data4.lists[0].imgUrl || '';
        console.log('about--res6==', res6);
        const res61 = await getAppInfo('key-about-m-history-title');
        this.pageData.data4.title = res61.data.baseData.content;
        console.log('about--res61==', res61);



        const res7 = await getAppInfo('key-about-m-business-title');
        this.pageData.data2.title = res7.data.baseData.content;
        console.log('about--res7==', res7);
        const res8 = await getAppInfo('key-about-m-business-desc');
        this.pageData.data2.sub_title = res8.data.baseData.content;
        console.log('about--res8==', res8);
        const res9 = await getAppInfo('key-about-m-business-imgUrl');
        this.pageData.data2.img = res9.data.baseData.content;
        console.log('about--res9==', res9);

        const res10 = await itemList({type: 5});
        this.pageData.data5.lists = res10.data.baseData || [];
        console.log('about--res10==', res10);

        this.$set(this, 'pageData', this.pageData);
        console.log('about--this.pageData==', this.pageData);
      },

			changeNav(item) {
				console.log('changeNav--item==', item);
				if (item.id === 'product') {
					// this.showProductMenu = !this.showProductMenu;
					this.showProductMenu = true;
				} else {
					this.showProductMenu = false;
				}
				this.activeNav = item.id;
				// this.$router.push({path: '/pages/product'})
			},
			changeServiceIndex(index) {
				this.serviceIndex = index;
			},
			handleOpen(e) {
				console.log('handleOpen--e==', e);
			},
			handleClose(e) {
				console.log('handleClose--e==', e);
			},
			visibleChange(bool) {
				console.log('visibleChange--bool==', bool);
				this.productList = this.productList.map(d => {
					d.open = false;
					return d;
				})
			},
			switchProduct(item, index) {
				console.log('switchProduct--item==', item);
				console.log('switchProduct--index==', index);
				console.log('switchProduct--this.productList==', this.productList);
				let row = JSON.parse(JSON.stringify(item));
				row.open = item.open ? false : true;
				this.$set(this.productList, index, row)
			},
			selProduct(e) {
				console.log('selProduct--e==', e);
			},

			handleSliceStr(str, start = 0, end) {
				var str1 = JSON.parse(JSON.stringify(str));
				if (!str) {
					return '';
				}
				if (!end || end > str.length) {
					end = str.length;
				}
				return str1.slice(start, end);
			},
			// changeData2Index(num) {
			//   const max = Math.ceil(this.pageData.data2.lists.length / 4);
			//   console.log('changeData2Index--max==', max);

			//   if (num > 0 && this.data2Index < max) {
			//     this.data2Index += num;
			//   } else if (num < 0 && this.data2Index > 0) {
			//     this.data2Index += num;
			//   }
			// }
		}
	}
</script>

<style scoped lang="scss">
@import '../common/css/about.scss';
</style>



// WEBPACK FOOTER //
// src/pages/about.vue